export default [
	{
		path: '/doctor/list',
		name: 'doctorList',
		component: () => import('@/views/doctor/list.vue'),
		meta: { title: '全部医生' }
	}
]
